import { render, staticRenderFns } from "./smCard.vue?vue&type=template&id=4996ed24&scoped=true"
import script from "./smCard.vue?vue&type=script&lang=js"
export * from "./smCard.vue?vue&type=script&lang=js"
import style0 from "./smCard.vue?vue&type=style&index=0&id=4996ed24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4996ed24",
  null
  
)

export default component.exports